import { Gallery } from 'components';

const GalleryPage = () => {
	return <Gallery />;
};

export default GalleryPage;
